import { Observable } from 'rxjs'
import { hours } from '../services/company'
import { companyCourierHour, toggleDeclaredTime } from '../services/companyCourier'
import * as authenticationDuck from './authentication'
import { combineEpics } from 'redux-observable'

export const HOURS_FETCH_REQUEST = 'hours/FETCH_REQUEST'
export const HOURS_FETCH_SUCCESS = 'hours/FETCH_SUCCESS'
export const HOURS_FETCH_FAILURE = 'hours/FETCH_FAILURE'

export const HOURS_SAVE_REQUEST = 'hours/SAVE_REQUEST'
export const HOURS_SAVE_SUCCESS = 'hours/SAVE_SUCCESS'
export const HOURS_SAVE_FAILURE = 'hours/SAVE_FAILURE'

export const TOGGLE_DECLARED_TIME_REQUEST = 'hours/TOGGLE_DECLARED_TIME_REQUEST'
export const TOGGLE_DECLARED_TIME_SUCCESS = 'hours/TOGGLE_DECLARED_TIME_SUCCESS'
export const TOGGLE_DECLARED_TIME_FAILURE = 'hours/TOGGLE_DECLARED_TIME_FAILURE'

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  isSaving: false,
  saveError: null,
  isToggling: false,
  toggleError: null,
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case HOURS_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case HOURS_FETCH_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      }
    case HOURS_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    case HOURS_SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
        saveError: null,
      }
    case HOURS_SAVE_SUCCESS:
      return {
        ...state,
        isSaving: false,
        saveError: null,
      }
    case HOURS_SAVE_FAILURE:
      return {
        ...state,
        isSaving: false,
        saveError: action.errors,
      }

    case TOGGLE_DECLARED_TIME_REQUEST:
      return {
        ...state,
        isToggling: true,
        toggleError: null,
      }
    case TOGGLE_DECLARED_TIME_SUCCESS:
      return {
        ...state,
        isToggling: false,
        toggleError: null,
      }
    case TOGGLE_DECLARED_TIME_FAILURE:
      return {
        ...state,
        isToggling: false,
        toggleError: action.errors,
      }

    default:
      return state
  }
}

export const hoursRequest = (id, date) => ({
  type: HOURS_FETCH_REQUEST,
  id,
  date,
})

export const hoursSuccess = (payload) => ({
  type: HOURS_FETCH_SUCCESS,
  payload,
})

export const hoursFailure = (errors) => ({
  type: HOURS_FETCH_FAILURE,
  errors,
})

export const hoursSaveRequest = (courierId, hourData, companyId, date) => ({
  type: HOURS_SAVE_REQUEST,
  courierId,
  hourData,
  companyId,
  date,
})

export const hoursSaveSuccess = (payload) => ({
  type: HOURS_SAVE_SUCCESS,
  payload,
})

export const hoursSaveFailure = (errors) => ({
  type: HOURS_SAVE_FAILURE,
  errors,
})

export const toggleDeclaredTimeRequest = (hourId, declaredTimeId, companyId, date) => ({
  type: TOGGLE_DECLARED_TIME_REQUEST,
  hourId,
  declaredTimeId,
  companyId,
  date,
})

export const toggleDeclaredTimeSuccess = (payload) => ({
  type: TOGGLE_DECLARED_TIME_SUCCESS,
  payload,
})

export const toggleDeclaredTimeFailure = (errors) => ({
  type: TOGGLE_DECLARED_TIME_FAILURE,
  errors,
})

export const epic = combineEpics(hoursRequestEpic, hoursSaveRequestEpic, toggleDeclaredTimeRequestEpic)

export function hoursRequestEpic(action$) {
  return action$.ofType(HOURS_FETCH_REQUEST).mergeMap((action) =>
    Observable.ajax(hours({ params: { id: action.id, date: action.date } }))
      .mergeMap((res) => Observable.of(hoursSuccess(res.response), ...(!res.response.length ? [] : [])))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(hoursFailure())
      }),
  )
}

export function hoursSaveRequestEpic(action$) {
  return action$.ofType(HOURS_SAVE_REQUEST).mergeMap((action) =>
    Observable.ajax(
      companyCourierHour({
        params: { id: action.courierId },
        body: action.hourData,
      }),
    )
      .mergeMap((res) => {
        const actions = [hoursSaveSuccess(res.response)]
        // Si on a les infos pour rafraîchir, on déclenche aussi le fetch
        if (action.companyId && action.date) {
          actions.push(hoursRequest(action.companyId, action.date))
        }
        return Observable.of(...actions)
      })
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(hoursSaveFailure(err.response || err))
      }),
  )
}

export function toggleDeclaredTimeRequestEpic(action$) {
  return action$.ofType(TOGGLE_DECLARED_TIME_REQUEST).mergeMap((action) =>
    Observable.ajax(
      toggleDeclaredTime({
        params: {
          id: action.hourId,
          declaredTimeId: action.declaredTimeId,
        },
      }),
    )
      .mergeMap((res) => {
        const actions = [toggleDeclaredTimeSuccess(res.response)]
        // Rafraîchir les données après le toggle
        if (action.companyId && action.date) {
          actions.push(hoursRequest(action.companyId, action.date))
        }
        return Observable.of(...actions)
      })
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(toggleDeclaredTimeFailure(err.response || err))
      }),
  )
}
